import './style/footer.less'
import $ from 'jquery'
import footTab from './js/footer'
import lxWrap from '../common/js/lx'
import lxBid from '../common/js/lx-bid'
/**
 * 首页底部
 */
module.exports = {
    init: (config) => {

        // 初始化顶部站点导航
        footTab.init({
            'container': $('#index-footer'),
            'domain': config.domain || ''
        });
        let $footer = $('#index-footer')
        // 页尾曝光打点
        $(window).on('scroll', e => {
            var dfdisY = window.innerHeight ? window.innerHeight : document.body.clientHeight;
            var winHeight = $(window).height();
            let docHeight = $(document).height();
            var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            // 判断是否到底
            if ((winHeight + scrollTop) <= (docHeight - 100) && $footer.attr('data-lx') !== 'true') {
                lxWrap($footer, lxBid.footerViewBid, false, true)
                $footer.attr('data-lx','true')
            }
        });
        //页尾点击
        lxWrap($('.footer-links a'), lxBid.footerClickBid, false, false)
    }
}


// WEBPACK FOOTER //
// ./modules/footer-index/index.js